import { Store, Order, OrderItem, SubmitOrderState } from 'models'
import { TableInfo } from './TableInfo'

export enum AutofillStep {
  DeliveryAddress = 'delivery_address',
  BillingAddress = 'billing_address',
  PaymentInfo = 'payment_info',
  DeliveryFee = 'delivery_fee',
}

export type OrderingState = {
  store?: Store
  order?: Order

  isCartVisible: boolean
  isCartButtonVisible: boolean

  editingOrderItem?: OrderItem
  isEditOrderDialogVisible: boolean

  submitOrderState: SubmitOrderState

  tableInfo?: TableInfo

  isContinueAsGuest?: boolean

  autofillStep?: AutofillStep
}
